"use client";

import React from "react";
import { Facebook, Instagram, Twitter, Linkedin, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <>
        {[1, 2, 3].map(i => <div key={i} data-index={i} className="flex flex-col gap-4">
            <div className="h-4 w-24 bg-primary/20 animate-pulse rounded-md mb-2" />
            <div className="h-3 w-full bg-primary/10 animate-pulse rounded-md" />
            <div className="h-3 w-5/6 bg-primary/10 animate-pulse rounded-md" />
            <div className="h-3 w-4/6 bg-primary/10 animate-pulse rounded-md" />
          </div>)}
      </>;
  }
  const displayItems = menuItems && menuItems.length > 0 ? menuItems.slice(0, 3) : [{
    id: 'sv',
    label: 'Our Services',
    children: [{
      id: 's1',
      label: '18-Hole Walkthrough',
      href: '/PackagesPage'
    }, {
      id: 's2',
      label: 'Clubhouse Cinematic',
      href: '/PackagesPage'
    }, {
      id: 's3',
      label: 'Aerial Photography',
      href: '/PackagesPage'
    }, {
      id: 's4',
      label: 'Yardage Graphics',
      href: '/PackagesPage'
    }]
  }, {
    id: 'co',
    label: 'Company',
    children: [{
      id: 'c1',
      label: 'About Trow',
      href: '/AboutPage'
    }, {
      id: 'c2',
      label: 'Our Process',
      href: '/AboutPage'
    }, {
      id: 'c3',
      label: 'FAA Compliance',
      href: '/RequestAQuotePage'
    }, {
      id: 'c4',
      label: 'Contact Us',
      href: '/RequestAQuotePage'
    }, {
      id: 'c5',
      label: 'Consultation Call-to-Action',
      href: '/RequestAQuotePage'
    }]
  }, {
    id: 're',
    label: 'Resources',
    children: [{
      id: 'r1',
      label: 'Request a Quote',
      href: '/RequestAQuotePage'
    }, {
      id: 'r2',
      label: 'Arizona Golf Guide',
      href: '#'
    }, {
      id: 'r3',
      label: 'Privacy Policy',
      href: '#'
    }]
  }];
  return <>
      {displayItems.map((column, i) => <div key={column.id} data-index={i} className="flex flex-col gap-4">
          <h3 className="font-default font-semibold text-sm text-primary uppercase tracking-widest">
            {column.label}
          </h3>
          {column.children && column.children.length > 0 && <ul className="flex flex-col gap-3">
              {column.children.map((link, j) => <li key={link.id} data-index={j}>
                  <Link to={link.href || "#"} className="text-muted-foreground hover:text-primary transition-colors duration-300 font-default">
                    {link.label}
                  </Link>
                </li>)}
            </ul>}
        </div>)}
    </>;
}
export default function MarketplaceFooter() {
  const currentYear = new Date().getFullYear();
  const socials = [{
    name: 'Instagram',
    icon: Instagram,
    href: '#'
  }, {
    name: 'Twitter',
    icon: Twitter,
    href: '#'
  }, {
    name: 'LinkedIn',
    icon: Linkedin,
    href: '#'
  }, {
    name: 'Facebook',
    icon: Facebook,
    href: '#'
  }];
  const paymentMethods = [{
    name: 'FAA Part 107',
    src: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/faa_certified_badge.png'
  }, {
    name: 'Arizona Specialist',
    src: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/arizona_media_badge.png'
  }, {
    name: 'Drone Pro',
    src: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/drone_pro_association.png'
  }];
  const credentials = [{
    id: 1,
    text: "FAA Part 107 Certified"
  }, {
    id: 2,
    text: "Arizona Based"
  }, {
    id: 3,
    text: "Serving Golf Courses of All Sizes"
  }];
  return <section data-section-id="260151" id="footer" className="bg-background text-foreground text-xs pt-16 pb-8 border-t border-primary/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-16 mb-16">
          
          <div className="flex flex-col gap-8 lg:col-span-1">
            <Link to="/HomePage" className="inline-block w-fit">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <p className="text-muted-foreground leading-relaxed font-default">
              Helping golf courses showcase their story through cinematic aerial media and modern visual presentation.
            </p>
            <div className="flex flex-col gap-3 mt-2">
              <h4 className="font-default font-semibold text-sm text-primary uppercase tracking-widest">
                Follow Our Journey
              </h4>
              <div className="flex items-center gap-4">
                {socials.map((social, index) => {
                const Icon = social.icon;
                return <Link key={social.name} data-index={index} to={social.href} className="flex items-center justify-center size-9 rounded-lg border border-primary/30 text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 shadow-md" aria-label={social.name}>
                      <Icon className="size-4" />
                    </Link>;
              })}
              </div>
            </div>
          </div>

          <MenuProvider menu_id="17" className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-10 sm:gap-8">
            <FooterNavigation />
          </MenuProvider>

          <div className="flex flex-col gap-6 lg:col-span-1">
            <h3 className="font-default font-semibold text-sm text-primary uppercase tracking-widest">
              Professional Standards
            </h3>
            <ul className="flex flex-col gap-3">
              {credentials.map((item, i) => <li key={item.id} data-index={i} className="flex items-center gap-2 text-muted-foreground font-default">
                  <CircleCheck className="size-4 text-secondary" />
                  <span>{item.text}</span>
                </li>)}
            </ul>
            <div className="mt-2 pt-4 border-t border-primary/10">
              <Link to="mailto:info@trowsolutions.com" className="text-primary font-semibold hover:text-secondary transition-colors font-default text-sm">info@trowgolfmedia.com</Link>
            </div>
          </div>

        </div>

        <div className="border-t border-primary/10 pt-8 flex flex-col justify-center items-center">
          <p className="font-serif text-2xl md:text-3xl italic tracking-wide text-center text-primary">
            Every Course Has a Story Worth Showing.
          </p>
          <div className="pt-6 text-center">
            <p className="text-xs text-muted-foreground italic">
              Trow Golf Media is operated by Trow Solutions LLC.
            </p>
          </div>
        </div>

      </div>
    </section>;
}